import React from 'react';
import PropTypes from 'prop-types';

import useSticky from '~/../components/shared/hooks/use_sticky';

const StickyContentWrapper = ({ title, content, offset = 55 }) => {
  const [stuck, stickyRef] = useSticky(offset);

  return <>
    <div ref={ stickyRef }></div>
    <div className={ 'sticky' + (stuck ? ' stuck' : '') }
      style={ stuck ? { top: `${offset}px` } : {} }
      dangerouslySetInnerHTML={{ __html: content }}>
    </div>
  </>;
}

StickyContentWrapper.propTypes = {};

export default StickyContentWrapper;
